import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import { prepareNum, unitLabel } from '@services/helper.service';
import { APP_TEXTS } from '../../../../../texts/texts';

import './../styles.scss';

class ResultsOfDesignANZ extends React.Component {

	constructor(props) {
		super(props);

		this.prepareValue = props.prepareValue;
	}

	render() {
		return (
		<div className="calculation">
				{this.props.selectedItem && (
				<section className="list-type calculate-results-of-design">
				<Table bordered size="sm">
						<thead>
						<tr>
								<th>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_TENSION.Content}</th>
								<th>{unitLabel(this.props.loadUnit)}</th>
								<th>&beta;<sub>N</sub>&nbsp;=</th>
						</tr>
						</thead>
						<tbody>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_CONCRETE_CAPACITY.Content}</span>
										<span>&Phi;<sub>Nurc</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.diam_Nurc)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaN_ConcreteConeFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_STEEL_CAPACITY.Content}</span>
										<span>&Phi;<sub>Nus</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.diam_Nus)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaN_SteelFailure, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_PULL_THROUGH_CAPACITY.Content}</span>
										<span>&Phi;<sub>Nurp</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.diam_Nurp)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaN_PullOutFailure, true, 2, true)}</td>
						</tr>
						</tbody>
				</Table>
		
				<Table bordered size="sm">
						<thead>
						<tr>
								<th>{APP_TEXTS.CALCULATE_HEADER_SHEAR.Content}</th>
								<th>{unitLabel(this.props.loadUnit)}</th>
								<th>&beta;<sub>V</sub>&nbsp;=</th>
						</tr>
						</thead>
						<tbody>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_CONCRETE_EDGE_CAPACITY.Content}</span>
										<span>&Phi;<sub>Vurc</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.diam_Vurc)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaV_ConcreteShearCapacity, true, 2, true)}</td>
						</tr>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_STEEL_CAPACITY.Content}</span>
										<span>&Phi;<sub>Vus</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.diam_Vus)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaV_SteelFailure, true, 2, true)}</td>
						</tr>
						</tbody>
				</Table>
		
				<Table bordered size="sm">
						<thead>
						<tr>
								<th>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_MOMENT.Content}</th>
								<th>{unitLabel(this.props.loadUnit)}</th>
								<th>&beta;<sub>V</sub>&nbsp;=</th>
						</tr>
						</thead>
						<tbody>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESIGN_BENDING_CAPACITY.Content}</span>
										<span>&Phi;<sub>Mu</sub></span>
								</div>
								</th>
										<td>{this.prepareValue(this.props.selectedItem.diam_Mu)}</td>
										<td>{prepareNum(this.props.selectedItem.BetaM_BendingFailure, true, 2, true)}</td>
						</tr>
						</tbody>
				</Table>

				<Table bordered size="sm">
						<tbody>
						<tr>
								<th scope="row">
								<div className="d-flex">
										<span>{APP_TEXTS.CALCULATE_RESULTS_DESGIN_UTILIZATION_EQUATION.Content}</span>
										<span className="utilization">
											&beta;<sub>N</sub>&nbsp;+&nbsp;&beta;<sub>V</sub>&nbsp;=
										</span>
								</div>
								</th>
								<td>{prepareNum(this.props.selectedItem.Beta, true, 2, true)}</td>
						</tr>
						</tbody>
				</Table>
				</section>
				)}
		</div>
		);
	}
    
}

const mapState = state => {
  const data = state.selectors.calculate[state.main.appType];

  if (data && data.gridSelectedItem) {
    return {
      selectedItem: data.gridSelectedItem,
      loadUnit: state.main.units.load,
    };
  }

  return {};
};
  
const mapDispatch = dispatch => ({
});
  
export default connect(mapState, mapDispatch)(ResultsOfDesignANZ);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateResultsOfDesign/components/ResultsOfDesignANZ.js